import { StyledEngineProvider } from "@mui/styled-engine";
import { SnackbarProvider } from "notistack";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./app/App";
import "./custom.css";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <StyledEngineProvider injectFirst>
    <BrowserRouter>
      <SnackbarProvider anchorOrigin={{ horizontal: "right", vertical: "top" }}>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </SnackbarProvider>
    </BrowserRouter>
  </StyledEngineProvider>
);
